import clsx from "clsx";
import React, { useState } from "react";
import SockJS from "sockjs-client";
import "./index.scss";
// https://www.seismicportal.eu/
const EarthQuake = (props) => {
  const { className } = props;
  const [info, setInfo] = useState({});
  // https://www.npmjs.com/package/sockjs-client

  var sock = new SockJS("https://www.seismicportal.eu/standing_order");
  // sock.onopen = function () {
  //   console.log("open");
  // };

  sock.onmessage = function (e) {
    // console.log("message", e.data);
    setInfo(JSON.parse(e.data));
    // console.log("new message");
  };

  // sock.onclose = function () {
  //   console.log("close");
  // };

  return (
    !!info && (
      <div
        className={clsx(
          "EarthQuake magnitude-colors flex-it flex-wrap",
          className
        )}
      >
        <div className="comp-wrap">
          <div className="comp-cont flex-it flex-align-item-center flex-wrap">
            {typeof info === "object" && !!info?.data && (
              <span
                className={clsx(
                  "magnitude-item",
                  `magnitude-${Math.floor(info?.data?.properties?.mag)}`,
                  info?.data?.properties?.mag < 0 ? "magnitude-under-zero" : ""
                )}
              >
                <span className="live-text">Earthquake: </span>
                Magnitude:{" "}
                <span className="magnitude">{info?.data?.properties?.mag}</span>
                ,
                {info?.data?.properties?.flynn_region?.indexOf(",") !== -1
                  ? info?.data?.properties?.flynn_region?.split(",")?.[1]
                  : info?.data?.properties?.flynn_region}
                {!!info?.data?.properties?.time
                  ? `, ${new Date(info?.data?.properties?.time)
                      ?.toString()
                      ?.replaceAll("(Eastern European Standard Time)", "")}`
                  : ""}
                ,
                <a
                  rel="noreferrer"
                  className="link"
                  target={"_blank"}
                  href={`https://www.google.com/maps/search/?api=1&query=${info?.data?.properties?.lat},${info?.data?.properties?.lon}`}
                >
                  Map Link
                </a>
              </span>
            )}
            {typeof info === "object" && !info?.data && (
              <>
                <span className="live-text">Live earthquake: </span>
                <span className="no-data">No Data</span>
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default EarthQuake;
